// Answer text can come from independently generated text and image metadata.
// Treat consecutive whitespace as a single separator so invisible spacing
// differences cannot make the correct image fail validation.
export const normalizeAnswerText = (value) => String(value ?? '')
    .trim()
    .replace(/\s+/g, ' ');
